import type { AxiosRequestConfig } from 'axios';

import client from '../client';
import type { ChatReference, ReplySuggestionRequest, ReplySuggestionResponse } from 'types';

export type { ChatReference };

export function get_chat_messages(groupId: string, customConfig?: AxiosRequestConfig) {
    const url = `/chat_messages/${groupId}`;
    return client.get(url, customConfig);
}

export function get_chat_groups(customConfig?: AxiosRequestConfig) {
    const url = '/chat_groups';
    return client.get(url, customConfig);
}

export function get_application_chat_messages(
    applicationId: string,
    isBackoffice: boolean,
    customConfig?: AxiosRequestConfig
) {
    const url = `/application_chat_messages/${applicationId}`;
    const params = { is_backoffice: isBackoffice ? 1 : 0 };

    const config = {
        ...customConfig,
        params,
    };

    return client.get(url, config);
}

export function get_chat_group(user_id: number, customConfig?: AxiosRequestConfig) {
    const url = '/chat_group';
    return client.post(
        url,
        {
            user_ids: [user_id],
        },
        customConfig
    );
}

// "references": [
//         {"type": "document", "id": 123},
//         {"type": "application", "id": 456},
//         {"type": "agreement", "id": 789},
// ]
export function send_message(
    chat_group_id: number,
    text: string,
    references?: ChatReference[],
    customConfig?: AxiosRequestConfig
) {
    const url = `/message`;
    return client.post(
        url,
        {
            chat_group_id,
            text,
            references: references ?? [],
        },
        customConfig
    );
}

export function update_message(
    message_id: number,
    text: string,
    customConfig?: AxiosRequestConfig
) {
    const url = `/message/${message_id}`;
    return client.put(
        url,
        {
            text,
        },
        customConfig
    );
}

export function has_unread_messages(application_id: string, customConfig?: AxiosRequestConfig) {
    const url = `/has-unread-messages/${application_id}`;
    return client.get(url, customConfig);
}

export function poll_messages(
    chat_group_id: number,
    last_polled_at: string,
    customConfig?: AxiosRequestConfig
) {
    const url = `/poll-messages/${chat_group_id}/${last_polled_at}`;
    return client.get(url, customConfig);
}

export function has_access(chat_group_id: number, customConfig?: AxiosRequestConfig) {
    const url = `/chat_groups/${chat_group_id}/has-access`;
    return client.get(url, customConfig);
}

export function get_reply_suggestion(
    candidateId: number,
    payload: ReplySuggestionRequest = {},
    customConfig?: AxiosRequestConfig<ReplySuggestionRequest>
) {
    const url = `/candidates/${candidateId}/reply-suggestion`;
    return client.post<ReplySuggestionResponse>(url, payload, customConfig);
}
